import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import RequestCard from "./RequestCard";

// Section config — label + right annotation + accent color
const SECTION_CONFIG = {
  AT_PMO:   { label: "AT PMO",                  right: "AWAITING PMO REVIEW",        color: "#28B3B4" },
  AT_SCG:   { label: "AT SCG GATE",             right: "PMO APPROVED — AWAITING SCG", color: "#D6DF27" },
  ACTIVE:   { label: "ACTIVE ALLOCATIONS",      right: null,                          color: "#28B3B4" },
  REJECTED: { label: "REJECTED — ACTION REQUIRED", right: null,                       color: "#c84040" },
};

const SectionGroup = ({ status, requests, onResubmit  }) => {
  const theme  = useTheme();
  const t      = theme.custom;

  if (!requests?.length) return null;

  const cfg = SECTION_CONFIG[status] || { label: status, right: null, color: t.accent };

  return (
    <Box sx={{ mb: "24px" }}>

      {/* Section header */}
      <Box sx={{
        display: "flex", alignItems: "center",
        justifyContent: "space-between",
        mb: "10px",
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "9px", letterSpacing: "0.18em",
            textTransform: "uppercase", color: cfg.color,
          }}>
            {cfg.label}
          </Typography>

          {/* Count badge */}
          <Box sx={{
            padding: "1px 7px", borderRadius: "3px",
            background: `${cfg.color}18`,
            border: `1px solid ${cfg.color}33`,
          }}>
            <Typography sx={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "9px", color: cfg.color,
            }}>
              {requests.length}
            </Typography>
          </Box>
        </Box>

        {cfg.right && (
          <Typography sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "9px", letterSpacing: "0.1em",
            textTransform: "uppercase", color: t.text3,
          }}>
            {cfg.right}
          </Typography>
        )}
      </Box>

      {/* Cards */}
      {requests.map((r) => (
        <RequestCard key={r.requestCode} request={r} onResubmit={onResubmit} />
      ))}
    </Box>
  );
};

export default SectionGroup;